/* eslint-disable prettier/prettier */
<template>
  <v-container fluid class="exams">
    <v-card flat>
      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1"> Exam Booking </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!--BEGIN exam booking card-->
        <v-tab-item :value="'tab-1'">
          <ExamBookingCard />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import { helper } from "../../dashboard/utils";
import ExamBookingCard from "@/packages/exams/components/examBookingCard";
// import UnitHistory from "@/packages/exams/components/unitHistory";
// import ProgramCurriculum from "@/packages/exams/components/programCurriculum";
export default {
  name: "BookingsComponent",
  components: {
    // ProgramCurriculum,
    // UnitHistory,
    ExamBookingCard,
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      // v.$store.dispatch("Exam/getExamBookings");
      v.$store.dispatch("Exam/currentProgramme");
      v.$store.dispatch("Exam/examCenters");
      v.$store.dispatch("Exam/studentBookings");
      v.$store.dispatch("Exam/studentRegistrations");
      // v.$store.dispatch("Exam/getExamWithdrawals");
      window.document.title = "KISEB:: Exam Bookings";
    });
  },
  data: () => ({
    tab: null,
    headers: [
      { text: "#S/N", sortable: false, value: "ID" },
      { text: "Unit Name", align: "start", sortable: false, value: "paper" },
      { text: "Stage", align: "start", sortable: false, value: "stage" },
      {
        text: "Exam Center",
        align: "start",
        sortable: false,
        value: "examCenter",
      },
      { text: "Exam Date", sortable: false, value: "examDate" },
      { text: "Start Time", sortable: false, value: "startTime" },
      { text: "End Time", sortable: false, value: "endTime" },
      { text: "Actions", value: "actions" },
    ],
  }),
  methods: {
    formatDate(date) {
      return helper.getDateFormat(date);
    },
    formatTime(time) {
      return helper.getTimeFormat(time);
    },
  },
};
</script>
<style scoped>
@import url("../styles/exam.css");
</style>
